/* eslint-disable no-unused-vars */
import React from "react";
import { motion } from "framer-motion";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

const annualIncomes = [
  { id: 1, name: "$12,000-$49,999" },
  { id: 2, name: "$50,000-$99,999" },
  { id: 3, name: "$100,000-$249,999" },
  { id: 4, name: "$250,000-$499,999" },
  { id: 5, name: "$500,000+" },
];

const Income = ({ setIncome, handleNext, step, setStep, income }) => {
  const handleAnswer = (answer) => {
    const answerStr = answer.toString();
    setIncome([answerStr]);
  };

  const handleBack = () => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const containerVariant = {
    hidden: { opacity: 0, x: 60, scale: 0.98 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.08,
        duration: 0,
        ease: [0.1, 1, 0.36, 1],
      },
    },
    exit: {
      opacity: 0,
      x: -60,
      scale: 0.96,
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
  };

  const itemVariant = {
    hidden: {
      opacity: 0,
      clipPath: "inset(0 100% 0 0)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      clipPath: "inset(0 0% 0 0)",
      transition: { duration: 0.5, ease: "easeInOut" },
    },
  };

  const CustomRadio = ({
    name,
    value,
    label,
    id,
    required = false,
  }) => {
    const isSelected = income?.includes(value?.toString());

    return (
      <label
        className={`taxqa-option d-flex taxqa-radio ${
          isSelected ? "taxqa-selected" : ""
        } taxqa-question-background`}
        htmlFor={id}
      >
        <input
          type="radio"
          name={name}
          id={id}
          value={value}
          checked={isSelected}
          onChange={() => handleAnswer(value)}
          required={required}
          className="taxqa-input-hidden"
        />
        <span className="taxqa-option-label fs-5">{label}</span>
      </label>
    );
  };

  const nextDisabled = !(income?.length > 0);

  return (
    <div className="taxqa-card-wrapper">
      <motion.div
        key={`income-step-${step}`}
        className="taxqa-card px-4 d-flex justify-content-center border-0"
        variants={containerVariant}
        initial="hidden"
        animate="visible"
      >
        <div className="card-body mt-0 d-flex justify-content-center">
          <motion.div className="taxqa-inner">
            <motion.h2
              className="taxqa-question-title"
              variants={itemVariant}
            >
              What is your annual income?
            </motion.h2>

            <motion.p
              className="taxqa-question-subtitle"
              variants={itemVariant}
            >
              Choose only one.
            </motion.p>

            <div className="taxqa-options-group">
              {annualIncomes.map((incomeOption) => (
                <motion.div
                  key={incomeOption.id}
                  variants={itemVariant}
                  className="taxqa-option-row"
                >
                  <CustomRadio
                    name="annual_income"
                    value={incomeOption.id}
                    label={incomeOption.name}
                    id={`income-${incomeOption.id}`}
                    required={true}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="card-footer border-0 d-flex justify-content-between taxqa-footer">
          <div className="d-flex justify-content-between w-100 taxqa-footer-btns">
            <button className="taxqa-btn-secondary" onClick={handleBack}>
              <FiArrowLeft className="taxqa-btn-arrow" />
              Previous
            </button>
            <button
              className="taxqa-btn-primary"
              onClick={() => handleNext(false)}
              disabled={nextDisabled}
            >
              Next
              <FiArrowRight className="taxqa-btn-arrow" />
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Income;
